/* ==========================================================================
   BLAST'N GEAR — Compression Theme JS  (vanilla, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.BNG || { routes: {}, cart: {}, strings: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money formatting (Shopify money_format aware) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || CFG.cart.moneyFormat || '${{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, p, t, d) {
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + (t || ','));
      var dec = parts[1] ? (d || '.') + parts[1] : '';
      return intPart + dec;
    }
    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.BNGformatMoney = formatMoney;

  /* ---------- Scroll lock + overlay ---------- */
  var overlay = $('[data-overlay]');
  var openLayers = 0;
  function lockScroll() { openLayers++; document.body.style.overflow = 'hidden'; if (overlay) { overlay.hidden = false; requestAnimationFrame(function(){ overlay.classList.add('is-active'); }); } }
  function unlockScroll(force) {
    openLayers = force ? 0 : Math.max(0, openLayers - 1);
    if (openLayers === 0) {
      document.body.style.overflow = '';
      if (overlay) { overlay.classList.remove('is-active'); setTimeout(function(){ if (openLayers === 0) overlay.hidden = true; }, 250); }
    }
  }
  if (overlay) overlay.addEventListener('click', function () { closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  function closeAll() {
    var mn = $('#MobileNav'); if (mn) mn.classList.remove('is-open');
    var cd = $('#CartDrawer'); if (cd) cd.classList.remove('is-open');
    unlockScroll(true);
  }

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t) { var mn = $('#MobileNav'); if (mn) { mn.classList.add('is-open'); lockScroll(); } }
    if (e.target.closest('[data-menu-close]')) { var m = $('#MobileNav'); if (m) m.classList.remove('is-open'); unlockScroll(); }
  });

  /* ==========================================================================
     CART DRAWER
     ========================================================================== */
  var Cart = {
    open: function () {
      var d = $('#CartDrawer');
      if (!d) { window.location.href = CFG.routes.cart_url || '/cart'; return; }
      d.classList.add('is-open'); lockScroll();
      this.refresh();
    },
    close: function () { var d = $('#CartDrawer'); if (d) d.classList.remove('is-open'); unlockScroll(); },
    refresh: function () {
      var self = this;
      fetch(CFG.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); });
    },
    render: function (cart) {
      this.updateCount(cart.item_count);
      this.updateFreeShip(cart.total_price);
      var wrap = $('#CartItems');
      var foot = $('#CartFoot');
      var bundleNote = $('#CartBundleNote');
      if (!wrap) return;
      if (!cart.items || cart.items.length === 0) {
        wrap.innerHTML = '<div class="cart-empty"><p class="eyebrow">Your bag is empty</p><p class="text-muted">Lock in the launch offer on the new compression drop.</p><a href="' + (CFG.routes.collectionUrl || '/collections/all') + '" class="btn" data-cart-close>Shop the Drop</a></div>';
        if (foot) foot.style.display = 'none';
        if (bundleNote) bundleNote.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      var html = '';
      cart.items.forEach(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x$1') : '';
        var media = img ? '<img src="' + img + '" alt="' + escapeHtml(it.product_title) + '" loading="lazy">' : '<div class="placeholder-media"></div>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cart-item__variant">' + escapeHtml(it.variant_title) + '</div>' : '';
        html += '<div class="cart-item" data-line="' + (i + 1) + '">' +
          '<a class="cart-item__media" href="' + it.url + '">' + media + '</a>' +
          '<div class="cart-item__info">' +
            '<a href="' + it.url + '"><div class="cart-item__title">' + escapeHtml(it.product_title) + '</div></a>' +
            variant +
            '<div class="qty qty--sm" data-qty>' +
              '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
              '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-line-qty="' + (i + 1) + '" aria-label="Quantity">' +
              '<button type="button" data-qty-up aria-label="Increase">+</button>' +
            '</div>' +
            '<button class="cart-item__remove" data-remove="' + (i + 1) + '">Remove</button>' +
          '</div>' +
          '<div class="cart-item__right"><div class="cart-item__price">' + formatMoney(it.final_line_price) + '</div></div>' +
        '</div>';
      });
      wrap.innerHTML = html;
      var sub = $('#CartSubtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
      // bundle messaging: show reminder until 2+ shirts in cart
      if (bundleNote) {
        var shirtQty = cart.items.reduce(function (a, it) { return a + (/(compression shirt)/i.test(it.product_title) ? it.quantity : 0); }, 0);
        bundleNote.style.display = shirtQty >= 4 ? 'none' : 'flex';
      }
    },
    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count < 1;
      });
    },
    updateFreeShip: function (total) {
      if (!CFG.cart.freeShipBar) return;
      var bars = $$('[data-freeship]');
      var threshold = CFG.cart.threshold || 0;
      bars.forEach(function (bar) {
        var fill = $('[data-freeship-fill]', bar);
        var msg = $('[data-freeship-msg]', bar);
        var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
        if (fill) fill.style.width = pct + '%';
        if (msg) {
          if (total >= threshold) {
            msg.innerHTML = '🎉 ' + (CFG.strings.freeShipUnlocked || "You've unlocked FREE shipping!");
          } else {
            msg.innerHTML = "You're <b>" + formatMoney(threshold - total) + "</b> away from FREE shipping";
          }
        }
      });
    }
  };
  window.BNGCart = Cart;

  /* delegated cart actions */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); Cart.open(); }
    if (e.target.closest('[data-cart-close]')) { Cart.close(); }
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(rm.getAttribute('data-remove'), 0); }
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (up || down) {
      var box = (up || down).closest('[data-qty]');
      if (!box) return; // product-page qty (data-product-qty) is handled by the product module
      var input = $('input', box);
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      val = up ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      var line = input.getAttribute('data-line-qty');
      if (line) changeLine(line, val);
      else input.dispatchEvent(new Event('change'));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (input) changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10) || 0);
  });

  function changeLine(line, qty) {
    fetch(CFG.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      Cart.render(cart);
      // also refresh full cart page if present
      if (document.body.classList.contains('template-cart')) window.location.reload();
    });
  }

  /* ---------- Add to cart (delegated for quick-add + cart upsell) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    submitAdd(form);
  });
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addById(qa.getAttribute('data-quick-add'), 1, qa); }
  });

  function submitAdd(form) {
    var btn = $('[type="submit"]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = CFG.strings.adding || 'Adding…'; }
    fetch(CFG.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { flash(btn, 'Unavailable'); }
      else { Cart.open(); }
    }).catch(function(){ flash(btn,'Error'); })
    .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }

  function addById(id, qty, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = CFG.strings.adding || 'Adding…'; }
    fetch(CFG.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) flash(btn, 'Unavailable');
      else Cart.open();
    }).finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  window.BNGaddById = addById;

  function flash(btn, msg) { if (!btn) return; var o = btn.innerHTML; btn.innerHTML = msg; setTimeout(function(){ btn.innerHTML = o; }, 1500); }

  /* ==========================================================================
     ACCORDIONS
     ========================================================================== */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.accordion__btn');
    if (!b) return;
    var acc = b.closest('.accordion');
    acc.classList.toggle('is-open');
    b.setAttribute('aria-expanded', acc.classList.contains('is-open'));
  });

  /* ==========================================================================
     PRODUCT PAGE
     ========================================================================== */
  function initProduct(root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', root);
    var idInput = $('[name="id"]', form);
    var qtyInput = $('[data-qty-input]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var addBtn = $('[data-add-btn]', root);
    var stickyTitle = $('[data-sticky-price]', root);
    var selected = {};

    // init options from first available variant
    var firstAvail = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (firstAvail) firstAvail.options.forEach(function (o, i) { selected[i] = o; });

    function findVariant() {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
    }

    function variantAvailableFor(optIndex, value) {
      return product.variants.some(function (v) {
        if (!v.available) return false;
        return v.options.every(function (o, i) {
          if (i === optIndex) return o === value;
          return selected[i] === undefined || selected[i] === o || true;
        }) && v.options[optIndex] === value;
      });
    }

    function update() {
      var v = findVariant();
      $$('.opt', root).forEach(function (b) {
        var oi = parseInt(b.getAttribute('data-opt-index'), 10);
        var val = b.getAttribute('data-opt-value');
        b.classList.toggle('is-selected', selected[oi] === val);
      });
      // selected-value labels
      $$('[data-selected-for]', root).forEach(function (el) {
        var oi = parseInt(el.getAttribute('data-selected-for'), 10);
        el.textContent = selected[oi] || '';
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price); compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (stickyTitle) stickyTitle.textContent = formatMoney(v.price * (parseInt(qtyInput && qtyInput.value, 10) || 1));
      $$('[data-add-btn]', root).forEach(function (btn) { btn.disabled = !v.available; });
      $$('[data-add-label]', root).forEach(function (l) { l.textContent = v.available ? (CFG.strings.addToCart || 'Add to Cart') : (CFG.strings.soldOut || 'Sold Out'); });
      // swap gallery to variant image
      if (v.featured_image && v.featured_image.id) {
        var t = $('.gallery__thumb[data-media-id="' + v.featured_image.id + '"]', root);
        if (t) t.click();
      }
    }

    // option buttons
    $$('.opt', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var oi = parseInt(b.getAttribute('data-opt-index'), 10);
        selected[oi] = b.getAttribute('data-opt-value');
        update();
      });
    });

    // gallery
    var mains = $$('.gallery__main img', root);
    $$('.gallery__thumb', root).forEach(function (th) {
      th.addEventListener('click', function () {
        $$('.gallery__thumb', root).forEach(function (x) { x.classList.remove('is-active'); });
        th.classList.add('is-active');
        var idx = th.getAttribute('data-index');
        mains.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-index') === idx); });
      });
    });

    // qty
    var qtyBox = $('[data-product-qty]', root);
    if (qtyBox) {
      $('[data-qty-up]', qtyBox) && $('[data-qty-up]', qtyBox).addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value,10)||1)+1; syncBundle(); update(); });
      $('[data-qty-down]', qtyBox) && $('[data-qty-down]', qtyBox).addEventListener('click', function () { qtyInput.value = Math.max(1,(parseInt(qtyInput.value,10)||1)-1); syncBundle(); update(); });
    }

    // bundle selector → sets quantity
    function syncBundle() {
      var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      $$('.pdp-bundle', root).forEach(function (pb) {
        pb.classList.toggle('is-selected', parseInt(pb.getAttribute('data-bundle-qty'),10) === q);
      });
    }
    $$('.pdp-bundle', root).forEach(function (pb) {
      pb.addEventListener('click', function () {
        var q = parseInt(pb.getAttribute('data-bundle-qty'), 10) || 1;
        if (qtyInput) qtyInput.value = q;
        $$('.pdp-bundle', root).forEach(function (x) { x.classList.remove('is-selected'); });
        pb.classList.add('is-selected');
        update();
      });
    });

    update();
    syncBundle();
  }

  /* ==========================================================================
     INIT
     ========================================================================== */
  function init() {
    $$('[data-product-root]').forEach(initProduct);
    // initial cart count + free ship from server-rendered or fetch
    fetch((CFG.routes.cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { Cart.updateCount(cart.item_count); Cart.updateFreeShip(cart.total_price); })
      .catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
})();

/* ===== Bundle upsell modal (self-contained) ===== */
(function () {
  function init() {
    var modal = document.getElementById('BundleModal');
    if (!modal) return;
    var root = document.querySelector('[data-product-root]');
    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); }

    var seen = false;
    try { seen = sessionStorage.getItem('bng_bundle_seen') === '1'; } catch (e) {}
    if (!seen) {
      setTimeout(function () {
        open();
        try { sessionStorage.setItem('bng_bundle_seen', '1'); } catch (e) {}
      }, 1100);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bundle-modal-close]')) { close(); return; }
      var ch = e.target.closest('[data-bundle-choose]');
      if (!ch) return;
      var q = ch.getAttribute('data-bundle-choose');
      if (root) {
        var pick = root.querySelector('.pdp-bundle[data-bundle-qty="' + q + '"]');
        if (pick) { pick.click(); }
        else {
          var qtyInput = root.querySelector('[data-qty-input]');
          if (qtyInput) { qtyInput.value = q; }
        }
      }
      close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
